export default "/images/winthadennisbackground.jpg?c042074a623ee3c1b1e8bb6687195e6d";